import React, { useLayoutEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import './CreativePreferences.css';
import { useBootstrapPreferences } from './state/usePreferences';
import { CreativePreferencesStore } from './state/store';
import { isAdminBuild } from './runtime';
import Shell from './Shell';

/**
 * The client's own form, or a staff read of it.
 *
 * `chrome` is whatever the host app puts above the page (its navbar) and
 * `useStoreToken` is its token bootstrap, because both differ between the
 * customer app and the professional app. `readOnly` forces the staff read:
 * the professional app has no write access at all.
 */
const CreativePreferencesPage = ({
  chrome,
  useStoreToken,
  navSelector,
  staff,
  readOnly: forcedReadOnly
}) => {
  const {
    booking_id: bookingId
  } = useParams();
  const [params] = useSearchParams();
  // The brief uuid comes off the deep link ops generates in the egadmin Planner.
  const briefUuid = params.get('brief') || 'local';
  const readOnly = forcedReadOnly
    // egadmin's staff view links here with ?readonly=true.
    || params.get('readonly') === 'true'
    // Login as User: the admin build (REACT_APP_IS_ADMIN=true) uses the
    // client's own token, so only the build tells us ops is the one reading.
    || isAdminBuild();
  // Ops opens a past round straight from the View Status modal.
  const snapshot = params.get('snapshot') || null;
  const {
    storeToLocal
  } = useStoreToken();

  // Must run before the bootstrap effect: it moves ?token= into localStorage and
  // strips it from the address bar, so the staff token is not left copyable.
  useLayoutEffect(() => {
    storeToLocal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useBootstrapPreferences({
    bookingId,
    briefUuid,
    readOnly,
    snapshot
  });
  return React.createElement(React.Fragment, null, chrome, React.createElement(Shell, {
    navSelector: navSelector,
    staff: staff
  }));
};
const CreativePreferences = props => React.createElement(CreativePreferencesStore, null, React.createElement(CreativePreferencesPage, {
  ...props
}));
export default CreativePreferences;
